import axios from 'axios'

export default{
    postData(data){
        return axios.post('https://hrv.insec.org.np/api/v1/download-info',data);
    }
}